import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const ProductContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 75%;
  justify-content: space-between;
  gap: ${props => props.theme.spacing.sp16};
  background-color: ${props => props.theme.colors.info.surface};
  border-radius: ${props => props.theme.primitives.radius.radius4};
  padding: ${props => props.theme.spacing.sp8};
`

export const ProductRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp16};
  padding: ${props => props.theme.spacing.sp8};
`

export const ProductInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const StatsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: ${props => props.theme.colors.background.primary};
  border-radius: ${props => props.theme.primitives.radius.radius2};
  padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp16};
  gap: ${props => props.theme.spacing.sp16};
`

export const Stat = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  align-items: center;
`
